<template>
    <div class="a-table--really-wide">
        <h1>{{name}}</h1>
        <h3>{{description}}</h3>
        <table class="a-table" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
                <th>
                    Age
                </th>
                <th style="cursor: pointer" @click="selectColumn(index)" v-for="(header, index) in headers">
                    {{ header }}
                </th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(number, index) in ageRange">
                    <td>{{index > index ? index + 1 : number }}</td>
                    <td :class="{'disabled' : !value[index]}" v-for="value in eachTableAvailable">
                        {{ value[index] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import Selector from 'pages/resources-and-tools/OgdenTables/mixins/Selector';

    export default {
        props: [
            'tableData',
            'name',
            'description'
        ],
        mixins: [
            Selector
        ],
        computed: {
            headers() {
                return Object.keys(this.tableData).map(table => {
                    return this.tableData[table]['title'];
                });
            },
            eachTableAvailable() {
                return Object.keys(this.tableData).map(table => {
                    return this.tableData[table]['data'];
                })
            },
            ageRange() {
                return Math.max(...Object.keys(this.tableData).map(table => {
                    return Object.keys(this.tableData[table]['data']).reduce( (max, arr) => max >= arr ? max : arr, -Infinity);
                })) + 1;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// AtAglanceViewer.vue?dbce8e12